import { Component, Directive, Input, signal, TemplateRef, ViewContainerRef } from '@angular/core'

import { FeatureFlagService } from '../services/feature-flag.service'
import { FeatureFlagKeys } from '../types/feature-flag.type'

@Directive({
	selector: '[appFeatureFlag]',
	standalone: true,
})
export class FeatureFlagDirective {
	hasView = signal(false)

	constructor(
		private readonly featureFlagService: FeatureFlagService,
		private readonly viewContainerRef: ViewContainerRef,
		private readonly templateRef: TemplateRef<FeatureFlagDirective>,
	) {}

	@Input() set appFeatureFlag(feature: FeatureFlagKeys) {
		if (this.featureFlagService.getFeature(feature) && !this.hasView()) {
			this.viewContainerRef.createEmbeddedView(this.templateRef)
			this.hasView.set(true)
		} else {
			this.viewContainerRef.clear()
			this.hasView.set(false)
		}
	}

	@Input() set featureFlagElse(elseTemplateRef: TemplateRef<Component>) {
		if (!this.hasView()) {
			this.viewContainerRef.createEmbeddedView(elseTemplateRef)
		}
	}
}
